import axiosClient from '../libs/axios';

// Hatırlatıcı türleri
export const REMINDER_TYPES = {
  DOMAIN: 'domain',
  HOSTING: 'hosting',
  SSL: 'ssl',
  BACKUP: 'backup',
  OTHER: 'other'
};

// Hatırlatıcı durumları
export const REMINDER_STATUS = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  COMPLETED: 'completed'
};

// API'den gelen hatırlatıcıyı frontend formatına çevir
export const formatReminderFromApi = (apiReminder) => {
  return {
    id: apiReminder.id,
    projectId: apiReminder.project_id,
    name: apiReminder.reminder_name,
    description: apiReminder.description || '',
    type: apiReminder.type,
    endDate: apiReminder.end_date ? apiReminder.end_date.split('T')[0] : '',
    reminderDays: apiReminder.reminder_days || 30,
    status: apiReminder.status,
    createdBy: apiReminder.created_by,
    createdAt: apiReminder.created_at,
    updatedAt: apiReminder.updated_at,
    creator: apiReminder.creator ? 
      `${apiReminder.creator.ufname} ${apiReminder.creator.ulname}` : '',
    project: apiReminder.project ? {
      id: apiReminder.project.id,
      name: apiReminder.project.pname
    } : null
  };
};

// Frontend formatından API formatına çevir
export const formatReminderForApi = (reminder) => {
  return {
    reminder_name: reminder.name,
    description: reminder.description || null,
    type: reminder.type,
    end_date: reminder.endDate,
    reminder_days: reminder.reminderDays || 30,
    status: reminder.status || REMINDER_STATUS.ACTIVE
  };
};

// Proje hatırlatıcılarını getir
export const getReminders = async (projectSlug) => {
  try {
    const response = await axiosClient.get(`/reminders/${projectSlug}`);
    return {
      reminders: response.data.reminders.map(formatReminderFromApi),
      total: response.data.total
    };
  } catch (error) {
    throw error;
  }
};

// Yeni hatırlatıcı oluştur
export const createReminder = async (projectSlug, reminderData) => {
  try {
    const formattedData = formatReminderForApi(reminderData);
    const response = await axiosClient.post(`/reminders/${projectSlug}`, formattedData);
    return {
      message: response.data.message,
      reminder: formatReminderFromApi(response.data.reminder)
    };
  } catch (error) {
    throw error;
  }
};

// Hatırlatıcıyı güncelle
export const updateReminder = async (reminderId, reminderData) => {
  try {
    const formattedData = formatReminderForApi(reminderData);
    const response = await axiosClient.put(`/reminders/${reminderId}`, formattedData);
    return {
      message: response.data.message,
      reminder: formatReminderFromApi(response.data.reminder)
    };
  } catch (error) {
    throw error;
  }
};

// Hatırlatıcıyı sil
export const deleteReminder = async (reminderId) => {
  try {
    const response = await axiosClient.delete(`/reminders/${reminderId}`);
    return {
      message: response.data.message
    };
  } catch (error) {
    throw error;
  }
};

// Tek hatırlatıcıyı getir
export const getReminder = async (reminderId) => {
  try {
    const response = await axiosClient.get(`/reminders/single/${reminderId}`);
    return formatReminderFromApi(response.data.reminder);
  } catch (error) {
    throw error;
  }
};

// Proje hatırlatıcı istatistiklerini getir
export const getReminderStatistics = async (projectSlug) => {
  try {
    const response = await axiosClient.get(`/reminders/statistics/${projectSlug}`);
    return response.data.statistics;
  } catch (error) {
    throw error;
  }
};

// Yaklaşan hatırlatıcıları getir
export const getUpcomingReminders = async () => {
  try {
    const response = await axiosClient.get('/reminders/upcoming');
    return {
      reminders: response.data.upcoming_reminders.map(formatReminderFromApi),
      total: response.data.total
    };
  } catch (error) {
    throw error;
  }
};

// Hatırlatıcıyı tamamlandı olarak işaretle
export const completeReminder = async (reminderId) => {
  try {
    const response = await axiosClient.post(`/reminders/${reminderId}/complete`);
    return {
      message: response.data.message,
      reminder: formatReminderFromApi(response.data.reminder)
    };
  } catch (error) {
    throw error;
  }
};

// Hatırlatıcı türü etiketleri
export const getReminderTypeLabel = (type) => {
  const labels = {
    [REMINDER_TYPES.DOMAIN]: 'Domain',
    [REMINDER_TYPES.HOSTING]: 'Hosting',
    [REMINDER_TYPES.SSL]: 'SSL',
    [REMINDER_TYPES.BACKUP]: 'Yedekleme',
    [REMINDER_TYPES.OTHER]: 'Diğer'
  };
  return labels[type] || 'Bilinmeyen';
};

// Hatırlatıcı durumu etiketleri
export const getReminderStatusLabel = (status) => {
  const labels = {
    [REMINDER_STATUS.ACTIVE]: 'Aktif',
    [REMINDER_STATUS.EXPIRED]: 'Süresi Dolmuş',
    [REMINDER_STATUS.COMPLETED]: 'Tamamlandı'
  };
  return labels[status] || 'Bilinmeyen';
};

// Hatırlatıcı durumu renkleri
export const getReminderStatusColor = (status) => {
  const colors = {
    [REMINDER_STATUS.ACTIVE]: 'green',
    [REMINDER_STATUS.EXPIRED]: 'red',
    [REMINDER_STATUS.COMPLETED]: 'blue'
  };
  return colors[status] || 'gray';
};

// Hatırlatıcı türü renkleri
export const getReminderTypeColor = (type) => {
  const colors = {
    [REMINDER_TYPES.DOMAIN]: 'purple',
    [REMINDER_TYPES.HOSTING]: 'orange',
    [REMINDER_TYPES.SSL]: 'yellow',
    [REMINDER_TYPES.BACKUP]: 'indigo',
    [REMINDER_TYPES.OTHER]: 'gray'
  };
  return colors[type] || 'gray';
};
